import type { AttentionItem, OperationEvent } from "../../domain/operations";

export function AttentionCard({ item, event, onReview, onResolve }: { item: AttentionItem; event: OperationEvent; onReview: () => void; onResolve: () => void }) {
  return (
    <article className={`attention-card ${item.kind === "blocker" ? "urgent" : ""}`}>
      <div className={`attention-icon ${item.kind}`}>{item.kind === "blocker" ? "!" : item.kind === "change" ? "↻" : "⌛"}</div>
      <div>
        <div className="attention-meta"><span>{item.kind.toUpperCase()}</span><time>{item.timeLabel}</time></div>
        <h3>{item.title}</h3>
        <p>{item.detail}</p>
        <div className="attention-event"><i className={`event-dot ${event.color}`} /><span>{event.name}</span></div>
        {item.kind === "blocker" ? <div className="card-actions"><button onClick={onResolve}>Resolve</button><button onClick={onReview}>Review update</button></div> : <button className="text-button" onClick={onReview}>Review impact →</button>}
      </div>
    </article>
  );
}
